import notify from '@helpers/toastify-helper';
import { IActivityStates } from '@helpers/types/activity';
import activityLogs from '@services/activity.service';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import OrderProgressSkeleton from '@components/common/acitivity-tab/skeleton';
import ActivityTab from '@components/common/acitivity-tab';

const ActivityCard = () => {
  const params = useParams();
  const [activityState, setActivityState] = useState<IActivityStates>({
    activityList: [],
    isLoading: false
  });
  const { activityList, isLoading } = activityState;

  useEffect(() => {
    (async () => {
      setActivityState((prevState) => ({ ...prevState, isLoading: !prevState.isLoading }));
      const response = await activityLogs(params.id as string);
      if (response.success) {
        setActivityState((prevState) => ({
          ...prevState,
          isLoading: !prevState.isLoading,
          activityList: response?.data ?? []
        }));
      } else {
        setActivityState((prevState) => ({ ...prevState, isLoading: !prevState.isLoading }));
        notify({
          message: response.error ?? 'Unable to fetch data',
          severity: 'error',
          dismissible: true
        });
      }
    })();
  }, []);

  if (isLoading) return <OrderProgressSkeleton />;

  return (
    <ActivityTab
      activityList={activityList}
      isLoading={isLoading}
      emptyStateConfig={{
        title: 'No Activity performed on this order yet',
        supportingText: 'When any activity is performed on this order, it will show up here.',
        buttonText: '',
        to: ''
      }}
      defaultUserName="Elchemy Internal Member"
    />
  );
};

export default ActivityCard;
